// eslint-disable-next-line @typescript-eslint/naming-convention
export function GasDebounce(time: number = 300) {
  let timeout = null;

  return function(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const original = descriptor.value;

    descriptor.value = function(...args: any) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        original.apply(this, args);
      }, time);
    };

    return descriptor;
  };
}
